import React from 'react';
import { connect } from 'react-redux';
import { startSetMapType } from '../actions/globalState';
import PropTypes from 'prop-types';
import { Button, Icon } from 'antd';
import { Link } from "react-router-dom";
const ButtonGroup = Button.Group;
export class MapType extends React.Component {
  state = {
    disabled: "terrain"
  };
  static propTypes = {
    onUpdate: PropTypes.func
  };

  onSetMapType = (value) => {
    this.props.startSetMapType(value);
    this.setState({
      disabled: value,
    })
  };

  disabledStatus = (value) => {
    return this.state.disabled === value ? true : false;
  };

  setPrimary = (value) => {
    return this.state.disabled === value ? "primary" : "default";
  }
  
  onUpdate = (e) => {
    if (typeof this.props.onUpdate === 'function') {
      this.props.onUpdate(e);
    }
  }
  render() {
    //console.log('this.state', this.state.disabled)
    return (
      <div className="map-types">
      <Link to="/" onClick={this.onUpdate}><Icon type="close" /></Link>
        <h3>Change map type</h3>
        <ButtonGroup>
          <Button type={this.setPrimary('light')} disabled={this.disabledStatus('light')}
          onClick={value => this.onSetMapType("light")}>Light</Button>
          <Button type={this.setPrimary('terrain')} disabled={this.disabledStatus('terrain')}
          onClick={value => this.onSetMapType("terrain")}>Terrain</Button>
          <Button type={this.setPrimary('dark')} disabled={this.disabledStatus('dark')}
          onClick={value => this.onSetMapType("dark")}>Dark</Button>
      </ButtonGroup>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  startSetMapType: (text) => dispatch(startSetMapType(text))
});

export default connect(undefined, mapDispatchToProps)(MapType);



// WEBPACK FOOTER //
// ./src/components/MapType.js